<!-- ProjectDetailModal.vue -->
<template>
  <v-navigation-drawer
    v-model="internalShow"
    right
    temporary
    fixed
    :width="drawerWidth"
    app
  >
    <v-card elevation="0" style="padding: 15px">
      <v-card-title class="d-flex align-center">
        <div class="text-h4 font-weight-medium">
          {{ quote.name }}
        </div>
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text>
        <v-card
          outlined
          class="mt-4"
          v-for="(sq, index) in supplierQuotes"
          :key="index"
        >
          <v-card-text>
            <div style="padding: 1.5em">
              <v-row>
                <v-col cols="12" class="d-flex">
                  <v-icon medium class="mr-1">mdi-file-outline</v-icon>
                  <div class="font-weight-medium">
                    <b>{{ sq.supplier.business_name }}</b> te envio una
                    cotización.
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-btn
                    small
                    rounded
                    dark
                    elevation="0"
                    style="margin: auto"
                    @click="showFile(sq.file_url)"
                  >
                    Ver cotización
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
        <v-card outlined class="mt-4" v-if="supplierQuotes.length == 0">
          <v-card-text>
            <div>
              <div class="d-flex align-center justify-between">
                <v-icon medium>mdi mdi-clock-outline</v-icon>
                <div class="text-h6 ml-2">Se esta cotizando tu material</div>
              </div>
              <v-col cols="12" v-if="quote.phone">
                <v-chip
                  color="green lighten-4"
                  text-color="green darken-2"
                  class="font-weight-bold"
                >
                  Te notificaremos por Whatsapp al {{ quote.phone }}
                </v-chip>
              </v-col>
            </div>
          </v-card-text>
        </v-card>

        <v-divider class="my-4"></v-divider>

        <div class="font-weight-medium">Detalle de tu solicitud</div>
        <div
          class="mt-2"
          style="border-radius: 6px; background: #ececec; padding: 1em"
        >
          <pre
            class="p-4"
            style="
              white-space: pre-wrap; /* preserva saltos de línea, pero sí envuelve */
              word-break: break-word; /* fuerza quiebre dentro de palabras muy largas */
              margin: 0; /* quita márgenes extra del pre */
            "
            >{{ quote.description }}</pre
          >
        </div>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import QuoteService from "@/services/quoteService";

export default {
  name: "QuotesDetailView",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    quoteId: {
      type: [String, Number],
      required: true,
      default: null,
    },
  },
  data() {
    return {
      quote: {},
      loading: false,
      epa: true,
      supplierQuotes: [],
      internalShow: this.value,
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    drawerWidth() {
      return this.$vuetify.breakpoint.mdAndDown ? "100%" : "40%";
    },
  },

  watch: {
    value(val) {
      this.internalShow = val;
      if (val && this.quoteId) this.getQuote(this.quoteId);
    },
    internalShow(val) {
      if (!val) {
        this.$emit("input", false);
        this.$router.push({ name: "projects" });
      }
    },
    quoteId: {
      immediate: true,
      handler(id) {
        if (id) this.getQuote(id);
      },
    },
  },
  methods: {
    async getQuote() {
      try {
        const response = await QuoteService.getById(this.quoteId);
        if (response.ok) {
          const quote = await response.json();
          this.quote = quote;
          this.supplierQuotes = quote.supplier_quotes;
          console.log(this.supplierQuotes);
        } else {
          console.error("Error al obtener cotizaciones:", response.status);
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
      }
    },

    close() {
      this.$emit("input", false);
      this.$router.push({ name: "projects" });
    },

    showFile(file) {
      window.open(file);
    },
  },
  filters: {
    currency(value) {
      if (value == null) return "—";
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      }).format(value);
    },
  },
};
</script>

<style scoped>
.v-navigation-drawer {
  /* Asegura que el drawer esté por encima */
  z-index: 2000;
}
</style>
